import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import PageLoader from '../../SharedComponents/PageState/PageLoader'
import PageNotice from '../../SharedComponents/PageState/PageNotice'
import { useGetConnectionInstanceQuery } from '../../../features/connections/connectionsApi'
import { useGetEndpointAuthUrlMutation } from '../../../features/endpointAuth/endpointAuthApi'
import useAuthorizedAction from '../../../features/account/useAuthorizedAction'
import { PATH } from '../../../app/routes'
const AuthenticateCard = ({ connection, endpoint, system }) => {
    const authorized = useAuthorizedAction()
    const [getEndpointAuthUrl] = useGetEndpointAuthUrlMutation()
    const [error, setError] = useState(null)
    const instanceType = connection.instances && connection.instances[0] ? connection.instances[0].instanceType : undefined
    const authenticate = () => {
        setError(null)
        authorized.run(() => getEndpointAuthUrl({ system, connectorId: connection.id, instanceType }).unwrap())
        .then((url) => window.open(url, '_self'))
        .catch((runError) => setError(runError.message || 'Authentication could not be started.'))
    }

    return (
        <div className="col-xl-6">
            <div className="card">
                <h4 className="card-header font-size-16">{endpoint.shortName} Authentication</h4>
                <div className="card-body">
                    <p className="card-title-desc">
                        Dear Subscriber, <br />
                        Click Authenticate button, In order to get Authenticated with {endpoint.shortName}
                    </p>
                    {error ? <p className="text-danger" role="alert">{error}</p> : null}
                    <button
                        className="btn btn-primary float-right i95-button"
                        type="button"
                        disabled={authorized.isBusy}
                        onClick={authenticate}
                    >
                        {authorized.isBusy ? 'Please wait...' : 'Authenticate'}
                    </button>
                </div>
            </div>
        </div>
    )
}
const Authentication = () => {
    const { connectorId, instanceId } = useParams()
    const { data: connection, isLoading, isError } = useGetConnectionInstanceQuery({ connectorId, instanceId })
    if (isLoading) {
        return <PageLoader message="Loading connector..." />
    }
    if (isError || !connection) {
        return (
            <PageNotice
                title="Connector not found"
                hint="It may have been removed, or the link is incomplete."
                linkTo={PATH.MY_PRODUCTS}
                linkLabel="Go to My Products"
            />
        )
    }

    return (
        <div className="main-content authentication">
            <div className="page-content pb-0">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex align-items-center justify-content-between mb-3 pb-0">
                                <h4 className="mb-0">Authentication</h4>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {connection.source.isAuthenticationRequired ? (
                            <AuthenticateCard connection={connection} endpoint={connection.source} system="QuickBooks" />
                        ) : null}
                        {connection.target.isAuthenticationRequired ? (
                            <AuthenticateCard connection={connection} endpoint={connection.target} system={connection.target.shortName} />
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Authentication
